import StorageFacade from './storageFacade';
import storageTypes from './storageTypes';
import LocalStorage from './storages/localStorage';

export const storage = {
    appStorage : StorageFacade,
    storageTypes: storageTypes,
    localstorage: LocalStorage
};
